var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.P_customClass},[_c(_vm.DV_componentType,{tag:"component"},[_vm._v(_vm._s(_vm.P_customCss))]),_vm._v(" "),_c('img',{directives:[{name:"show",rawName:"v-show",value:(_vm.C_isVisible),expression:"C_isVisible"}],style:(_vm.C_imageStyle),attrs:{"src":_vm.P_imageSrc}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-15529131","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Grid/GImage.vue
// module id = null
// module chunks = 